import { SEOHead } from "../../components/cheersup-v2";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Image from "next/image";
import { AboutUs, Discover, FAQ, Links } from "@/components/cheersup-v2/about";

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "cheersup-v2"])),
    },
  };
}

export default function CheersUpAbout() {
  return (
    <>
      <SEOHead />
      <style>{`body { background-color: black; }`}</style>

      <div className="">
        <div className="">
          <img
            src="/img/cheersup-v2/about-kv.png"
            alt=""
            className="w-full align-top"
          />

          <div className="align-top mt-[22px] h-[48px] bg-[url('/img/cheersup-v2/scroll-cup.gif')] bg-contain bg-repeat-x animate-[scrollxLogo_1.6s_linear_infinite] transform-gpu"></div>
        </div>

        <AboutUs />

        <Links />

        <FAQ />

        <Discover />
      </div>
    </>
  );
}
